import React from 'react'
import ReactDOM from 'react-dom/client'
import { App } from './App'
import './styles/variables.css'
import './styles/reset.css'
import './styles/global.css'

// Auto-reload on stale chunk errors (happens after deploys when SW has old precache)
// This catches "Failed to fetch dynamically imported module" errors and reloads once.
const RELOAD_KEY = '__milo_chunk_reload'

window.onerror = (msg) => {
  if (typeof msg === 'string' && msg.includes('dynamically imported module')) {
    if (!sessionStorage.getItem(RELOAD_KEY)) {
      sessionStorage.setItem(RELOAD_KEY, '1')
      window.location.reload()
      return true
    }
  }
}

window.onunhandledrejection = (e) => {
  const message = e.reason?.message || String(e.reason)
  if (message.includes('dynamically imported module') || message.includes('Failed to fetch')) {
    if (!sessionStorage.getItem(RELOAD_KEY)) {
      sessionStorage.setItem(RELOAD_KEY, '1')
      window.location.reload()
      return
    }
  }
}

// Clear the reload flag on successful load so future stale chunks can trigger reload again
sessionStorage.removeItem(RELOAD_KEY)

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
